import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import './styles/global.less'
import './styles/variables.less'

Vue.use(Antd)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
